import type { IconComponent } from './icon'

export const ArrowUpRight: IconComponent = ({ className }) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <title>Arrow Up Right</title>
            <path
                d="M18.5 15.5V7.5C18.5 6.39543 17.6046 5.5 16.5 5.5H8.5M6 18L17.5 6.5"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="square"
            />
        </svg>
    )
}
